import React from 'react';
import { connect } from 'react-redux';
import { GoalIcon } from '_components';
import { getDateMDYY } from '_helpers';
import styles from './Row.module.css';

class PatientCareCenterNoteGoalProgressRow extends React.Component {

    getProgressColor() {
        let retval = '';
        switch (this.props.goalProgress.GPVALUE) {
            case 100:
            case 90:
            case 80:
                retval = '#12ED22';
                break;
            case 70:
            case 60:
            case 50:
            case 40:
                retval = '#F7EB5B';
                break;
            default:
                retval = '#FF8000';
                break;
        }
        return retval;
    }

    getTitle() {
        let retval = this.props.activityName ? this.props.activityName : 'Blank Activity';
        retval += ' (';
        retval += this.props.goalProgress.GPVALUE;
        retval += '%)';
        retval += this.props.goal.GODATE ? ' - ' + getDateMDYY(this.props.goal.GODATE) : '';
        return retval;
    }


    render() {
        return (
            <div className={this.props.isOdd ? styles.wrapperOdd : styles.wrapper} title={this.getTitle()}>
                <span className={styles.col1}>
                    <GoalIcon id={this.props.goal.GOMGNO} />
                </span>
                <span className={styles.col2}>
                    <span className={styles.goal_text}>{this.props.shortName}</span>
                    <span className={styles.progress_container}>
                        {this.props.goalProgress.GPVALUE > 0 &&
                            <span className={styles.progress_meter} style={{ width: this.props.goalProgress.GPVALUE + '%', backgroundColor: this.getProgressColor() }} />
                        }
                    </span>
                </span>
            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalProgress = state.entities.masterData.PTMASTERGOALPROGRESS[1]; // default to "not started"
    if (goal.GOGPNO) {
        goalProgress = state.entities.masterData.PTMASTERGOALPROGRESS[goal.GOGPNO];
    } else if (goal.GOGPNOPREV) {
        goalProgress = state.entities.masterData.PTMASTERGOALPROGRESS[goal.GOGPNOPREV];
    }
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : undefined;
    let shortName = activityName
    if (activityName === 'perform essential job demand' && goal.GOWORKTASK) {
        activityName += ' (' + goal.GOWORKTASK + ')';
        shortName = goal.GOWORKTASK;
    }
    if (goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE)) {
        activityName = goal.GOCUSTOM ? goal.GOCUSTOM : undefined;
        shortName = activityName;
    }

    return {
        goal,
        goalProgress,
        activityName,
        shortName
    };
}

const connectedPatientCareCenterNoteGoalProgressRow = connect(mapStateToProps)(PatientCareCenterNoteGoalProgressRow);
export { connectedPatientCareCenterNoteGoalProgressRow as PatientCareCenterNoteGoalProgressRow };

